<mat-form-field (click)="formClick()" [ngStyle]="{ width: width }">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select
    [placeholder]="placeholder"
    [(value)]="default"
    [required]="required"
    [compareWith]="compareWith"
    (selectionChange)="selectionChanged($event.value)"
  >
    <mat-option *ngFor="let item of keyValueArray" [value]="item?.key">
      {{ item.value }}
    </mat-option>
  </mat-select>
</mat-form-field>
